/**
 * One place for cache keys. Every list key ends with its params object so
 * invalidating `['patients']` clears every page and filter combination at once.
 */
export const qk = {
  me: ['me'] as const,
  permissions: ['permissions'] as const,
  governorates: ['governorates'] as const,

  list: (resource: string, params?: unknown) =>
    params === undefined ? ([resource, 'list'] as const) : ([resource, 'list', params] as const),
  detail: (resource: string, id: string) => [resource, 'detail', id] as const,
  /** A list's per-status figures under the same filters (`…/counts`). */
  counts: (resource: string, params: unknown) => [resource, 'counts', params] as const,
  root: (resource: string) => [resource] as const,

  notificationsUnread: ['notifications', 'unread-count'] as const,
  dispenseScan: (token: string) => ['dispense', 'scan', token] as const,
} as const;
